export default "__VITE_ASSET__DGVncVZ6__"